var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0;fill:#808080;}\r\n\t.st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,4H16.7c-0.5,0-0.9,0.4-0.9,0.9v13.8H7.7l-0.3-2.4c0-0.2-0.2-0.4-0.4-0.4H4.4C4.2,15.8,4,16,4,16.3 c0,0.3,0.2,0.4,0.4,0.4h2.1l1.6,10.5C8.2,27.7,8.6,28,9,28h11.2c0.3,0,0.5,0.2,0.5,0.5S20.5,29,20.2,29H8.6 c-0.3,0-0.4,0.2-0.4,0.4c0,0.3,0.2,0.4,0.4,0.4H9c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.8,0.7,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4 c0-0.2,0-0.4-0.1-0.6h6.3c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.8,0.7,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4c0-0.2,0-0.4-0.1-0.6 c0.6-0.2,1.1-0.7,1.1-1.4c0-0.6-0.4-1.1-0.9-1.3l0.4-2.1h8.9c1.1,0,2.1-0.9,2.1-2.1V4.8C32,4.4,31.6,4,31.1,4z M10.9,30.5 c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6C10.6,30,10.9,30.2,10.9,30.5z M19.2,31.1 c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6C19.8,30.8,19.6,31.1,19.2,31.1z M21.3,19.5l-0.7,3.4h-2.3 v-3.4H21.3z M19.5,27.2h-1.2v-3.4h2.1l-0.6,3.4H19.5z M9,27.1l-0.5-3.3h2.3v3.4L9,27.1L9,27.1z M14.1,23.7v3.4h-2.4v-3.4H14.1z  M11.7,22.9v-3.4h2.4v3.4H11.7z M15,23.7h2.4v3.4H15V23.7z M17.4,22.9H15v-3.4h2.5V22.9z M10.8,19.5v3.4H8.4l-0.5-3.4H10.8z  M21.2,24.3l0.4-2.1h6.3v1c0,0.4,0.1,0.8,0.3,1.2H21.2z M31.1,23.1c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2v-1.4 c0-0.3-0.2-0.4-0.4-0.4h-6.5l0.3-1.6c0-0.3,0-0.5-0.2-0.7s-0.4-0.3-0.7-0.3h-4.5V4.8l14.4,0V23.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,8.3h8.5c0.3,0,0.4-0.2,0.4-0.4c0-0.3-0.2-0.4-0.4-0.4h-8.5c-0.3,0-0.4,0.2-0.4,0.4 C19.3,8,19.4,8.3,19.7,8.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,11.8h8.5c0.3,0,0.4-0.2,0.4-0.4c0-0.3-0.2-0.4-0.4-0.4h-8.5c-0.3,0-0.4,0.2-0.4,0.4 C19.3,11.5,19.4,11.8,19.7,11.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,15.3h8.5c0.3,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-8.5c-0.3,0-0.4,0.2-0.4,0.4S19.4,15.3,19.7,15.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,17.9h-4.2c-0.3,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h4.2c0.3,0,0.4-0.2,0.4-0.4 C28.6,18.1,28.4,17.9,28.2,17.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.83bbcc37.svg";
export { ForwardRef as ReactComponent };